import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchJobQueueStatusReportsTypes = getApiActionTypes('FETCH_JOB_QUEUE_STATUS_REPORTS');

export const terminateStuckCalcJobTypes = getApiActionTypes('TERMINATE_STUCK_CALC_JOB');
